import "./Home.scss"
const Home = () => {
  return (
    <div className="home">
      <div className="text">
        <p>My Name Is</p>
        <p className="name">Frida Kahlo</p>
        <p>Feminist Icon and Artist</p>
      </div>
    </div>
  )
}

export default Home
